var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.9172 26.5H10.2891V14.8164H13.9172V26.5ZM12.1012 13.2226C10.941 13.2226 10 12.2617 10 11.1016C10 10.5443 10.2214 10.0098 10.6154 9.6158C11.0095 9.22175 11.5439 9.00038 12.1012 9.00038C12.6584 9.00038 13.1929 9.22175 13.5869 9.6158C13.981 10.0098 14.2023 10.5443 14.2023 11.1016C14.2023 12.2617 13.2609 13.2226 12.1012 13.2226ZM27.4961 26.5H23.8758V20.8125C23.8758 19.457 23.8484 17.7187 21.9895 17.7187C20.1031 17.7187 19.8141 19.1914 19.8141 20.7148V26.5H16.1898V14.8164H19.6695V16.4101H19.7203C20.2047 15.4922 21.3879 14.5234 23.1531 14.5234C26.825 14.5234 27.5 16.9414 27.5 20.082V26.5H27.4961Z","fill":"black"}));
}

LinkedinIcon.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38","fill":"none"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
